module.exports = __webpack_public_path__ + "media/admin/cs_publication_001_lg-b6c82527.png";